function blogPath(siteTag, path = '') {
  const trimmedPath = String(path).replace(/(^\/blog\/|^\/)/, '');
  let blogLink = '';

  switch (siteTag) {
    default:
      blogLink = '/blog';
      break;
  }

  return `${blogLink}/${trimmedPath}`;
}

// Function to get current url
const getCurrURL = () => {
  if (typeof window !== 'undefined') {
    const urlString = window.location.href;
    const url = new URL(urlString);

    return url.href;
  } else {
    return '';
  }
};

module.exports = { blogPath, getCurrURL };
